import React from 'react';
import { ArcIconButton, ArcStack, ArcTooltip } from '@src/core/ui';
import { CAMERA_TOOLBAR_ICON_BUTTON_SX } from './toolbar-icon-button-sx';
import { cameraPillSx } from './camera-pill-sx';
import type { ToolbarItem } from './types';

interface CameraToolbarProps {
  items: ToolbarItem[];
}

const CameraToolbar: React.FC<CameraToolbarProps> = ({ items }) => (
  <ArcStack
    top={10}
    right={10}
    spacing={0.5}
    zIndex={100}
    direction='row'
    position='absolute'
    alignItems='center'
    sx={cameraPillSx}>
    {items.map((item) =>
      item.type === 'slot' ? (
        <React.Fragment key={item.key}>{item.node}</React.Fragment>
      ) : (
        <ArcTooltip key={item.key} title={item.key}>
          <ArcIconButton
            disabled={item.disabled}
            onClick={item.onClick}
            sx={CAMERA_TOOLBAR_ICON_BUTTON_SX}>
            {item.icon}
          </ArcIconButton>
        </ArcTooltip>
      )
    )}
  </ArcStack>
);

export default CameraToolbar;
